import adminUserList from "./admin-user-list/AdminUserList.vue";
import i18n from "../../i18n/index";
import userService from "../../services/users/userService";
import branchService from "../../services/branch/BranchService";

export default {
    components: {
        adminUserList
    },
    data: () => ({
        dialog: false,
        hideList: false,
        branchData: [],
        none: { id: '', name: i18n.t('none') },
        user: {
            id: null,
            name: '',
            username: '',
            email: '',
            password: '',
            role: '',
            provider: '',
            branch: '',
            active: true
        },
        showIcon: false,
        showUpdate: false,
        showAdd: true,
        rules: [value => !!value || i18n.t('field-required')],
        emailRules: [
            v =>
                /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                i18n.t('email-must-be-valid')
        ],
        items: {
            providers: [],
            branches: [],
            roles: []
        },
        passwordRules: [
            v => v === '' || v.length >= 8 || 'La contraseña debe tener al menos 8 caracteres',
            v => v === '' || /[A-Z]/.test(v) || 'La contraseña debe tener al menos una letra mayúscula',
            v => v === '' || /[0-9]/.test(v) || 'La contraseña debe tener al menos un número',
            v => v === '' || /[!@#$%^&*(),.?":{}|<>]/.test(v) || 'La contraseña debe tener al menos un carácter especial',
          ],
        validForm: true,
        loadingSaveButton: false,
        loadingDelete: false
    }),
    created() {
        this.getRoles();
        this.getProviders();
    },
    methods: {
        async handleUser(item) {
            this.hideList = true;
            this.showIcon = false;
            this.user.id = item.id;
            this.user.name = item.name;
            this.user.username = item.username;
            this.user.email = item.email;
            this.user.password = '';
            this.user.role = item.idRole.id;
            this.user.provider = item.idBranch ? item.idBranch.idProvider.id : '';

            if (this.user.provider !== '') {
                await this.getBranches();
            } else {
                this.items.branches = [this.none]
            }
            this.user.branch = item.idBranch ? item.idBranch.id : '';

            this.user.active = item.active;
            this.showAdd = false;
            this.showUpdate = true;
        },
        closeUser() {
            this.hideList = false;
            this.dialog = false;
            this.showIcon = false;
            this.items.branches = [];
            // this.$refs.form.reset();
            this.user = {
                id: null,
                name: '',
                username: '',
                email: '',
                password: '',
                role: '',
                provider: '',
                branch: '',
                type: '',
                active: true
            };
            this.showAdd = true;
            this.showUpdate = false
        },
        getProviders() {
            return userService.getProviders().then(response => {
                this.items.providers = [this.none, ...response.data];
                this.items.branches = [this.none];
                this.user.branch = '';
            });
        },
        async getBranches() {
            const providerId = this.user.provider
            if (providerId === '') {
                this.items.branches = [this.none]
                this.user.branch = ''
                return
            }
            try {
                const response = await branchService.getBranchesByprovider(providerId)
                this.items.branches = [this.none, ...response.data]
                this.user.branch = ''
            } catch (error) {
               console.log(error) 
            }
        },
        getRoles() {
            userService.getRoles().then(response => {
                this.items.roles = response.data;
            });
        },
        save() {
            if (this.$refs.form.validate()) {
                if (this.user.password === '' || this.user.password === undefined){
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'Debe ingresar una contraseña'
                    });
                    return
                }
                this.loadingSaveButton = true;
                userService.createUser(this.user)
                    .then(value => {
                        this.loadingSaveButton = false;

                        if (value) {
                            this.$notify({
                                group: "app",
                                type: "success",
                                text: this.user.id ? i18n.t("user.succesfull-updated-user") : i18n.t("user.user-successfully-created")
                            });
                            this.$refs.adminUserList.searchUser();
                            this.closeUser();
                        }
                    }).catch(error => {
                        this.loadingSaveButton = false;

                        if (error && error.message) {
                            if (error.message == 'ALREADY_USERNAME') {
                                this.$notify({
                                    group: "app",
                                    type: "error",
                                    text: i18n.t("user.username-already-taken")
                                });
                            } else if (error.message == 'ALREADY_EMAIL') {
                                this.$notify({
                                    group: "app",
                                    type: "error",
                                    text: i18n.t("user.email-already-taken")
                                });
                            } else {
                                this.$notify({
                                    group: "app",
                                    type: "error",
                                    text: error.message
                                });
                        }
            }});
            }
        },
        updateUser() {
            if (this.user.password !== '') {
                const passwordValidation = this.validatePassword(this.user.password);
                if (passwordValidation !== true) {
                  this.$notify({
                    group: "app",
                    type: "error",
                    text: passwordValidation,
                  });
                  return;
                }
              }
            let UserId = this.user.id;
            let data = {
                email: this.user.email,
                name: this.user.name,
                password: this.user.password,
                idRole: this.user.role,
                active: this.user.active == true ? 1 : 0,
                username: this.user.username,
                idBranch: this.user.branch
            };
            this.loadingSaveButton = true;
            userService.updateUsers(UserId, data).then(result => {
                this.loadingSaveButton = false;
                if (result.status == 201) {
                    this.$notify({
                        group: "app",
                        type: "success",
                        text: "Usuario Actualizado"
                    });
                    this.hideList = false;
                    this.$refs.adminUserList.searchUser();
                    this.closeUser();
                }
            }).catch(error => {
                this.loadingSaveButton = false;
                if (error && error.message) {
                    if (error.message == 'ALREADY_USERNAME') {
                        this.$notify({
                            group: "app",
                            type: "error",
                            text: i18n.t("user.username-already-taken")
                        });
                    } else if (error.message == 'ALREADY_EMAIL') {
                        this.$notify({
                            group: "app",
                            type: "error",
                            text: i18n.t("user.email-already-taken")
                        });
                    } else {
                        this.$notify({
                            group: "app",
                            type: "error",
                            text: error.message
                        });
                    }
                }   
            });
        },
        deteleUser() {
            let data = { id: this.user.id };
            this.loadingDelete = true;
            userService.deleteUsers(data).then(result => {
                if (result.data === 'The User has associated transactions') {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: "Usuario no pudo se eliminado, tiene Pedidos asociados."
                    });
                    this.hideList = false;
                    this.loadingDelete = false;
                    return;
                }
                if (result.status == 201) {
                    this.loadingDelete = false;
                    this.$notify({
                        group: "app",
                        type: "success",
                        text: 'Usuario Eliminado'
                    });
                    this.hideList = false;
                    this.loadingDelete = false;
                    this.$refs.adminUserList.searchUser();
                    this.closeUser();
                }
            }).catch(error => {
                this.loadingDelete = false;
                this.showIcon = false;
                this.$notify({
                    group: "app",
                    type: "error",
                    text: error
                });
            });
        },
        validatePassword(password) {
            for (let rule of this.passwordRules) {
              if (typeof rule === 'function') {
                const result = rule(password);
                if (result !== true) {
                  return result;
                }
              }
            }
            return true;
          },
    }
};
